export default __webpack_public_path__ + "static/media/mantle003.52fee842.jpeg";